<div *ngIf="isMobile">
  <app-page-header *ngIf="isMobile"></app-page-header>
  <div class="mobile-nav-title"></div>
  <div class="main-wrapper">
    <div class="container-fluid d-flex flex-column align-items-center text-bidit-primary">
      <router-outlet></router-outlet>
    </div>
    <div class="clearfix"></div>
  </div>
</div>

<div *ngIf="!isMobile">
  <div class="main-wrapper d-flex flex-column justify-content-center">
    <div class="container-fluid d-flex flex-column align-items-center text-bidit-primary">
      <router-outlet></router-outlet>
    </div>
    <div class="clearfix"></div>
  </div>
  <app-footer fullFooter="1"></app-footer>
</div>
